import {
    EzRegistrationState
} from '/ezlibrary/enums/EzEnumerations.js';

import { EzClass } from '/ezlibrary/EzClass.js';
import { EzVersionChecker } from '/ezlibrary/EzVersionChecker.js';

/**
 * @class
 * @extends {EzClass}
 * @description
 * Controller for the welcome page view
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import with:
 *     import { EzWelcomePage } from '/ezlibrary/welcome/EzWelcomeViewController.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Singleton instance ready for use when the below evaluates to true:
 *     globalThis.ezApi.ezclocker?.[EzWelcomePage.ezApiName]?.ready
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Listen to onReady event:
 *     EzClass.ezWaitReady(
 *         EzWelcomePage.ezEventNames.onReady,
 *         {listening_class}.#ezRegistrator);
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Singleton Instance Reference:
 *     Inside this class...: EzWelcomePage.ezInstance
 *     Outside this class..: globalThis.ezApi.ezclocker.ezWelcomePage
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
export class EzWelcomePage extends EzClass {
    /**
     * @public @constructor
     * Creates a new instance of EzWelcomePage
     */
    constructor() {
        super();

        this.scrolled = false;

        this.ezReviews = [
            {
                'comments': 'After careful review of many similar apps, the team at ezClocker gets it right. They understand and deliver. Their customer service matches their superior products.',
                'reviewer': 'onedaywebpages.com, via iTunes reviews'
            },
            {
                'comments': 'User friendly for my staff, the GPS/location system make me aware when and where they are, the quick reports for payroll and customer support was awesome. Love it, recommend definitely!!!',
                'reviewer': 'Cathryn owner of Maids with Care'
            },
            {
                'comments': 'I have thoroughly enjoyed the simplicity of using the clock-in/clock-out feature. My employees can clock in/out from our work PC or from their phone.. Easy to use and easy to export the pay period for my payroll department.',
                'reviewer': 'johnstonmom, via iTunes reviews'
            },
            {
                'comments': 'This app rocks! I own a small remodeling company (crew of 5) and this is the perfect app for me! Easy to use, and saves me tons of time!',
                'reviewer': 'Nick flagg, via iTunes reviews'
            },
            {
                'comments': 'Very simple and easy to use application. Great for people who have employees that work from home. It helps you keep people accountable and you will know when they clock in and out',
                'reviewer': 'joaxvargas, via iTunes reviews'
            }
        ];
    }

    /**
     * @public @method
     * Initializes EzWelcomePage
     *
     * @returns {EzWelcomePage}
     */
    ezInit() {
        $(document).scroll(globalThis.ezApi.p.ezWelcomePage.ezAdjustNavBar);

        if (768 <= globalThis.ezApi.ezclocker.ezUi.ezWindow().width()) {
            globalThis.ezApi.ezclocker.ezUi.ezId$('#ezcFooter a').removeAttr('data-toggle');
        }

        globalThis.ezApi.ezclocker.ezUi.ezHookElementEvent(
            '_EzContactUsButton',
            'click',
            () => globalThis.ezApi.ezclocker.ezNavigation.ezNavigateTo(
                `/welcome/contact.html?v=${EzVersionChecker.ezWebsiteVersion}`));

        EzWelcomePage.ezInstance.ezAdjustNavBar();

        return EzWelcomePage.ezInstance;
    }

    ezAdjustNavBar() {
        const mainNav = globalThis.ezApi.ezclocker.ezUi.ezId('mainNav');

        if (!EzWelcomePage.ezInstance.scrolled && 0 !== globalThis.ezApi.ezDocument().scrollTop()) {
            mainNav.addClass('scrolled');

            globalThis.ezApi.ezclocker.ezUi.ezSetElementAttribute(
                'ezcLogo',
                'src',
                '/public/images/logos/logo-white.svg');

            globalThis.ezApi.ezclocker.ezUi.ezId('ezNavPricing').addClass('nav-link-scrolled');

            globalThis.ezApi.ezclocker.ezUi.ezId('ezNavContact').addClass('nav-link-scrolled');

            globalThis.ezApi.ezclocker.ezUi.ezId('ezNavSignIn').addClass('nav-link-scrolled');

            EzWelcomePage.ezInstance.scrolled = true;
        } else if (EzWelcomePage.ezInstance.scrolled && 0 === globalThis.ezApi.ezDocument().scrollTop()) {
            globalThis.ezApi.ezclocker.ezUi.ezSetElementAttribute(
                'ezcLogo',
                'src',
                '/public/images/logos/logo.svg');

            mainNav.removeClass('scrolled');

            globalThis.ezApi.ezclocker.ezUi.ezSetElementAttribute('ezcLogo', 'src', '/public/images/logos/logo.svg');

            globalThis.ezApi.ezclocker.ezUi.ezId('ezNavPricing').removeClass('nav-link-scrolled');

            globalThis.ezApi.ezclocker.ezUi.ezId('ezNavContact').removeClass('nav-link-scrolled');

            globalThis.ezApi.ezclocker.ezUi.ezId('ezNavSignIn').removeClass('nav-link-scrolled');

            EzWelcomePage.ezInstance.scrolled = false;
        }
    }

    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // Class Initialization and EzApi Registration Section
    // !! DO NOT PLACE ANY non-initialization fields, getter/setter methods, static methods, or class methods beyond this section !!
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

    /**
     * @static
     * @public @readonly @property
     * Gets the name of this class's singleton instance when registered with globalThis.ezApi.
     * @returns {string}
     */
    static get ezApiName() {
        return 'ezWelcomePage';
    }

    /**
     * @static
     * @public @readonly @property
     * Gets an object of event names that this class may trigger.
     * @returns {object}
     */
    static get ezEventNames() {
        return {
            onReady: 'ezOn_EzWelcomePage_Ready'
        };
    }

    /**
     * @static
     * @private @field
     * Stores the singleton instance of this class that was created by and registerd with globalThis.ezApi.
     * @type {EzWelcomePage}
     */
    static #ezInstance = globalThis?.ezApi?.ready && globalThis.ezApi.ezclocker?.[EzWelcomePage.ezApiName]
        ? globalThis.ezApi.ezclocker[EzWelcomePage.ezApiName]
        : null;
    /**
     * @static
     * @public @property @getter
     * Gets the singleton instance of this class that is registered with EzApi (if available yet)
     * @returns {EzWelcomePage}
     */
    static get ezInstance() {
        return EzWelcomePage.#ezInstance;
    }
    /**
     * @static
     * @public @property @setter
     * Sets the singleton instance of of this class that is registered with globalThis.ezApi.
     * @param {EzWelcomePage} instance
     */
    static set ezInstance(instance) {
        if (null != EzWelcomePage.#ezInstance) {
            throw new Error('EzWelcomePage\'s singleton instance is already reigstered with globalThis.ezApi.');
        }

        EzWelcomePage.#ezInstance = instance;
    }

    /**
     * @static
     * @private @field
     * Stores the EzApi registration state for this class.
     * Default value is NULL
     * Class is registerd with EzApi when value is EzRegistrationState.REGISTERED
     * @type {string}
     * A valid enum property value from EzRegistrationState
     */
    static #ezApiRegistrationState = globalThis?.ezApi?.ready && globalThis.ezApi?.ezclocker?.[EzWelcomePage.ezApiName]?.ezApiRegistrationState
        ? EzRegistrationState.REGISTERED
        : EzRegistrationState.NOT_REGISTERED;
    /**
     * @static
     * @public @property @getter
     * Gets the ezApi registration state of this classes's singleton instance.
     * @returns {string}
     * A valid enum property value from EzRegistrationState
     */
    static get ezApiRegistrationState() {
        return EzWelcomePage.#ezApiRegistrationState;
    }
    /**
     * @static
     * @public @property @setter
     * Sets the ezApi registration state of this classes's singleton instance.
     * @param {string} ezApiRegistrationState
     * A valid enum property value from EzRegistrationState
     */
    static set ezApiRegistrationState(ezApiRegistrationState) {
        EzWelcomePage.#ezApiRegistrationState = EzRegistrationState.ezValueOf(ezApiRegistrationState);
    }

    /**
     * @static
     * @private @readonly @property
     * Gets true when all required dependencies for this class report ready.
     * In otherwords, the require dependency's singleton instance is created
     * and is registered with and accessable from EzApi with globalThis.ezApi.ezclocker.{dependency_name}.
     * @returns {boolean}
     * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     * ENGINEERING NOTES
     * Safe to ignore SonarLint hint javascript:S1541
     * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     */
    static get #ezCanRegister() {
        return EzRegistrationState.PENDING === EzWelcomePage.ezApiRegistrationState &&
            globalThis?.ezApi?.ready && globalThis.ezApi?.ezclocker;
    }

    /**
     * @static
     * @private @readonly @property
     * Gets if this class's singleton instance is registered with ezApi yet.
     * @returns {boolean}
     */
    static get #ezIsRegistered() {
        return null != EzWelcomePage.ezInstance &&
            EzRegistrationState.REGISTERED === EzWelcomePage.ezApiRegistrationState;
    }

    /**
     * @static
     * @private @method
     * Attempts to register the singleton instance for this class with globalThis.ezApi. Returns true
     * if successful, false otherwise.
     * @returns {boolean}
     */
    static #ezRegistrator() {
        if (EzWelcomePage.#ezCanRegister && !EzWelcomePage.#ezIsRegistered) {
            globalThis.ezApi.ezRegisterNewApi(EzWelcomePage, EzWelcomePage.ezApiName);
        }

        return EzWelcomePage.#ezIsRegistered;
    }

    /**
     * @static
     * Static Initialization
     * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     * >> IMPORTANT <<
     * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     * Make sure the following properties and methods get defined BEFORE this static initialization section:
     *      1) Property getter EzWelcomePage.ezApiName
     *      2) Property getter EzWelcomePage.ezEventNames
     *      3) Property getter EzWelcomePage.ezInstance
     *      4) Property setter EzWelcomePage.ezInstance
     *      5) Property getter EzWelcomePage.ezApiRegistrationState
     *      6) Property setter EzWelcomePage.ezApiRegistrationState
     *      7) Property getter EzWelcomePage.#ezCanRegister
     *      8) Property getter EzWelcomePage.#ezIsRegistered
     *      9) Method EzWelcomePage.#ezRegistrator()
     */
    static {
        if (!EzWelcomePage.#ezIsRegistered) {
            EzWelcomePage.ezApiRegistrationState = EzRegistrationState.PENDING;

            if (!EzWelcomePage.#ezRegistrator()) {
                EzClass.ezWaitReady(
                    EzWelcomePage.ezOnEzApiReadyEventName,
                    EzWelcomePage.#ezRegistrator);
            }
        }
    }

    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // !! DO NOT PLACE ANY non-initialization fields, getter/setter methods, static methods, or class methods beyond above section !!
    // NO CODE AFTER THIS SECTION
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
}
